export * from './navbar';
export * from './footer';
export * from './treatments';
export { default as Logo } from './Logo';
export { default as DesktopMenuLinks } from './DesktopMenuLinks';
export { default as MobileMenuLinks } from './MobileMenuLinks';
export { default as DropdownMenu } from './DropdownMenu';
export { default as Carousel } from './carousel/Carousel';
export { default as AccordionItem } from './accordion/AccordionItem';
export { default as Timeline } from './Timeline';
export { default as ContactForm } from './ContactForm';
export { default as Map } from './Map';
export { default as GTM } from './GTM';
export { default as JsonLD } from './JsonLD';
export { default as MiniHero } from './MiniHero';
export { default as WhatsappBtn } from './WhatsappBtn';
